export type SupportedLanguage = "sv" | "en";

export const STRINGS: Record<SupportedLanguage, Record<string, string>> = {
  sv: {
    "navbar.language": "Språk",
    "navbar.darkMode": "Mörkt läge",
    "navbar.overview": "Översikt",
    "navbar.map": "Karta",
    "navbar.forum": "Forum",
    "admin.forum.overviewTitle": "Moderatoröversikt",
    "admin.forum.overviewLead": "Det som behöver uppmärksamhet. Moderera direkt i forumet via inläggens meny (…).",
    "admin.forum.toForum": "Till forumet",
    "admin.forum.open": "Öppna",
    "admin.forum.openReports": "Öppna anmälningar",
    "admin.forum.hiddenPosts": "Dolda inlägg",
    "admin.forum.hiddenThreads": "{n} dolda trådar",
    "admin.forum.bannedMembers": "Avstängda",
    "admin.forum.postsWeek": "Inlägg, 7 dagar",
    "admin.forum.postsDay": "{n} senaste dygnet",
    "admin.forum.threadsWeek": "Nya trådar, 7 dagar",
    "admin.forum.newMembers": "{n} nya skribenter",
    "admin.forum.reports": "Anmälda inlägg",
    "admin.forum.noReports": "Inga öppna anmälningar.",
    "admin.forum.reportCount": "{n} anmälningar",
    "admin.forum.report1": "1 anmälan",
    "admin.forum.alreadyHidden": "redan dolt",
    "admin.forum.hiddenTitle": "Dolda inlägg",
    "admin.forum.noHidden": "Inga dolda inlägg.",
    "admin.forum.hiddenBy": "dolt av {name} {date}",
    "admin.forum.bannedTitle": "Avstängda medlemmar",
    "admin.forum.noBanned": "Inga avstängda medlemmar.",
    "admin.forum.bannedSince": "avstängd {date}",
    "admin.forum.postCount": "{n} inlägg",
    "admin.forum.latestPost": "Senaste inlägget",
    "admin.forum.editedTitle": "Nyligen redigerade inlägg",
    "admin.forum.editedLead": "Redigerade efter publicering, senaste 14 dagarna. Versionshistoriken finns i inläggets meny.",
    "admin.forum.noEdited": "Inga redigerade inlägg.",
    "admin.forum.editedMeta": "redigerad {date} · {n} tidigare versioner",
    "forum.mod.banned": "Avstängd",
    "forum.mod.reports": "{n} anmälningar",
    "forum.mod.report1": "1 anmälan",
    "forum.mod.showReports": "Visa anmälningar",
    "forum.mod.dismissReports": "Avfärda anmälningar",
    "forum.mod.noReason": "ingen anledning angiven",
    "forum.mod.noReports": "Inga öppna anmälningar.",
    "forum.mod.rename": "Byt medlemmens namn",
    "forum.mod.renamePrompt": "Nytt forumnamn för {name}:",
    "forum.mod.ban": "Stäng av från forumet",
    "forum.mod.unban": "Häv avstängning",
    "forum.mod.banConfirm": "Stänga av {name} från forumet? Medlemmen kan läsa men inte skriva eller rösta.",
    "forum.mod.unbanConfirm": "Häva avstängningen för {name}?",
    "forum.mod.createDaily": "Skapa dagens tråd",
    "forum.mod.rebuildDaily": "Uppdatera med senaste prognos",
    "forum.mod.dailyResult": "Dagens tråd för {date}: {status}",
    "forum.mod.status.created": "skapad",
    "forum.mod.status.updated": "uppdaterad",
    "forum.mod.status.exists": "finns redan",
    "forum.mod.status.waiting": "väntar på priserna",
    "forum.mod.status.no-data": "ingen data än",
    "forum.mode.write": "Skriv",
    "forum.mode.preview": "Förhandsgranska",
    "forum.mode.split": "Sida vid sida",
    "forum.fmt.codeBlock": "Kodblock",
    "forum.fmt.plainCode": "Annan / text",
    "forum.daily.outlookTitle": "Vår prognos {from} – {to}",
    "forum.daily.cheapestDay": "Billigaste dagen",
    "forum.daily.forecastMean": "{value} per kWh i snitt enligt prognosen",
    "forum.daily.knownTitle": "I morgon, {date}: redan satt",
    "forum.daily.tomorrowKnown": "I morgon (satt)",
    "forum.daily.weSaid": "vår prognos sa",
    "forum.nameLockNote": "Namnet går inte att ändra efter ditt första inlägg, så välj med omsorg.",
    "forum.memberSince": "Forumnamnet är låst efter första inlägget",
    "forum.eyebrow": "Community",
    "forum.write": "Skriv",
    "forum.preview": "Förhandsgranska",
    "forum.previewEmpty": "Inget att förhandsgranska än.",
    "forum.fmt.bold": "Fetstil",
    "forum.fmt.boldText": "fet text",
    "forum.fmt.italic": "Kursiv",
    "forum.fmt.italicText": "kursiv text",
    "forum.fmt.quote": "Citat",
    "forum.fmt.list": "Punktlista",
    "forum.fmt.code": "Kod",
    "forum.fmt.link": "Länk",
    "forum.fmt.linkText": "länktext",
    "forum.fmt.hint": "**fet**, *kursiv*, > citat, - lista, ```yaml för kodblock · Tab drar in · Ctrl+Enter skickar",
    "forum.dailyAvg": "dygnsmedel",
    "forum.dailyForecastAvg": "prognos, dygnsmedel",
    "forum.vsForecast": "Mot prognos",
    "forum.joinDiscussion": "Diskutera",
    "forum.votes": "Röster",
    "forum.statThreads": "trådar",
    "forum.statPosts": "inlägg",
    "forum.statMembers": "medlemmar",
    "forum.statToday": "senaste dygnet",
    "forum.statViews": "visningar",
    "forum.searchPlaceholder": "Sök i forumet…",
    "forum.allThreads": "Alla trådar",
    "forum.sort.active": "Aktiva",
    "forum.sort.new": "Nya",
    "forum.sort.top": "Topp",
    "forum.searchResults": "Resultat för ”{q}”",
    "forum.noResults": "Inga trådar matchar sökningen.",
    "forum.modPanel": "Moderering",
    "forum.joinTitle": "Var med i samtalet",
    "forum.joinLead": "Välj ett forumnamn så kan du starta trådar, svara och rösta.",
    "forum.topMembers": "Mest aktiva (30 dagar)",
    "forum.rulesTitle": "Forumregler",
    "forum.rule1": "Var schysst. Kritisera idéer, inte personer.",
    "forum.rule2": "Inga personuppgifter, inte dina egna heller.",
    "forum.rule3": "Ingen reklam eller spam. Tips om produkter går bra.",
    "forum.rule4": "Anmäl inlägg som bryter mot reglerna så tittar en moderator på dem.",
    "forum.moderator": "Moderator",
    "forum.op": "Trådstartare",
    "forum.replyingTo": "Svar till {name}",
    "forum.editNote": "Tidigare versioner sparas och kan ses av moderatorer.",
    "forum.ownPost": "Du kan inte rösta på ditt eget inlägg",
    "forum.upvote": "Rösta upp",
    "forum.share": "Dela",
    "forum.linkCopied": "Länken är kopierad.",
    "forum.more": "Mer",
    "forum.history": "Versionshistorik ({n})",
    "forum.modRename": "Byt rubrik",
    "forum.modHideThread": "Dölj tråden",
    "forum.modMove": "Flytta till",
    "forum.replyAs": "Svarar som",
    "forum.aboutThread": "Om tråden",
    "forum.started": "Startad",
    "forum.lastActivity": "Senaste aktivitet",
    "forum.repliesLabel": "Svar",
    "forum.viewsLabel": "Visningar",
    "forum.participants": "Deltagare",
    "forum.copyLink": "Kopiera länk",
    "forum.historyTitle": "Versionshistorik",
    "forum.currentVersion": "Nuvarande version",
    "forum.replacedAt": "Ersattes {date}",
    "forum.newLead": "Ställ en fråga, dela en lösning eller starta en diskussion. Trådar är publika.",
    "forum.titlePlaceholder": "Vad vill du diskutera?",
    "forum.bodyPlaceholder": "Berätta mer. Ju mer konkret, desto bättre svar.",
    "forum.tipsTitle": "Tips för en bra tråd",
    "forum.tip1": "Skriv en rubrik som säger vad tråden handlar om.",
    "forum.tip2": "Ange elområde och vad du har (batteri, värmepump, elbil) om det spelar roll.",
    "forum.tip3": "Sök först, kanske finns svaret redan.",
    "forum.formatTitle": "Formatering",

    "forum.title": "Forum",
    "forum.lead": "Diskutera elpriser, prognoser, batterier och styrning med andra användare. Trådarna är publika och syns även på spotprisprognos.se.",
    "forum.daily": "Dagens tråd",
    "forum.dailyOpen": "Öppna tråden",
    "forum.categories": "Kategorier",
    "forum.latest": "Senaste trådarna",
    "forum.threads": "{n} trådar",
    "forum.thread1": "1 tråd",
    "forum.replies": "{n} svar",
    "forum.reply1": "1 svar",
    "forum.noThreads": "Inga trådar än. Starta den första!",
    "forum.newThread": "Ny tråd",
    "forum.loadMore": "Visa fler",
    "forum.back": "Forum",
    "forum.pinned": "Fäst",
    "forum.locked": "Låst",
    "forum.hiddenThread": "Dold",
    "forum.staff": "Teamet",
    "forum.bot": "Automatisk",
    "forum.edited": "redigerad",
    "forum.deletedPost": "Inlägget har tagits bort av författaren.",
    "forum.hiddenPost": "Inlägget har dolts av en moderator.",
    "forum.reply": "Svara",
    "forum.replyPlaceholder": "Skriv ett svar…",
    "forum.send": "Skicka",
    "forum.sending": "Skickar…",
    "forum.edit": "Redigera",
    "forum.save": "Spara",
    "forum.cancel": "Avbryt",
    "forum.delete": "Ta bort",
    "forum.deleteConfirm": "Ta bort inlägget? Texten raderas.",
    "forum.report": "Anmäl",
    "forum.reportPrompt": "Varför anmäler du inlägget? (valfritt)",
    "forum.reported": "Tack, en moderator tittar på det.",
    "forum.lockedNotice": "Tråden är låst för nya svar.",
    "forum.bannedNotice": "Ditt konto kan inte skriva i forumet.",
    "forum.publicNotice": "Inlägg är publika och syns under ditt forumnamn, även för besökare som inte är inloggade.",
    "forum.notFound": "Tråden finns inte eller har tagits bort.",
    "forum.loadError": "Kunde inte ladda forumet.",
    "forum.category": "Kategori",
    "forum.threadTitle": "Rubrik",
    "forum.threadBody": "Inlägg",
    "forum.create": "Skapa tråd",
    "forum.nameTitle": "Välj ett forumnamn",
    "forum.nameLead": "Ditt forumnamn visas publikt vid dina inlägg. Använd inte ditt fullständiga namn eller din e-post om du vill vara anonym.",
    "forum.nameLabel": "Forumnamn",
    "forum.nameHint": "3–24 tecken: bokstäver, siffror, mellanslag, punkt, bindestreck eller understreck.",
    "forum.nameSave": "Spara namn",
    "forum.yourName": "Du skriver som {name}",
    "forum.changeName": "Byt namn",
    "forum.mod": "Moderera",
    "forum.modPin": "Fäst",
    "forum.modUnpin": "Lossa",
    "forum.modLock": "Lås",
    "forum.modUnlock": "Lås upp",
    "forum.modHide": "Dölj",
    "forum.modShow": "Visa",

    "forum.daily.final": "Spotpriser {date}",
    "forum.daily.forecast": "Prognos {date} (spotpriserna är inte publicerade än)",
    "forum.daily.zone": "Elområde",
    "forum.daily.avg": "Snitt",
    "forum.daily.min": "Lägst",
    "forum.daily.max": "Högst",
    "forum.daily.cheapest": "Billigaste 3 h",
    "forum.daily.ourForecast": "Vår prognos före auktionen",
    "forum.daily.outlook": "Prognos kommande dagar (dygnsmedel)",
    "forum.daily.hourly": "Timpris",

    "admin.forumTab": "Forum",
    "navbar.configure": "Konfigurera",
    "navbar.account": "Mitt konto",
    "navbar.upgrade": "Uppgradera",
    "navbar.logout": "Logga ut",

    "map.title": "Karta – händelser & produktion",
    "map.subtitle": "Spotpris per elområde, marknadshändelser och större produktionsanläggningar. Dra i tidsreglaget för att se priser bakåt i tiden och prognosen framåt.",
    "map.play": "Spela upp",
    "map.pause": "Pausa",
    "map.now": "Nu",
    "map.actual": "Spotpris",
    "map.forecast": "Prognos",
    "map.timeline": "Välj tidpunkt",
    "home.miniMap.title": "Elområden just nu",
    "home.miniMap.expand": "Öppna karta",
    "map.loading": "Laddar karta…",
    "map.layerPrices": "Spotpris per elområde",
    "map.layerEvents": "Marknadshändelser",
    "map.layerAssets": "Produktionsanläggningar",
    "map.legendPrice": "Spotpris (kr/kWh)",
    "map.legendPriceTitle": "Spotpris",
    "map.assetCapacity": "Installerad effekt",
    "map.assetZone": "Elområde",
    "map.assetType.nuclear": "Kärnkraft",
    "map.assetType.hydro": "Vattenkraft",
    "map.assetType.wind": "Vindkraft",
    "map.assetType.thermal": "Värmekraft",

    "home.title": "Prisprognos",
    "home.subtitle":
      "Elpris och spotpris - realtidspriser och elprisprognos",
    "home.noAccess": "Du har inte behörighet att visa prisdata. Kontakta en administratör för att få åtkomst.",
    "home.loadError": "Kunde inte ladda pris- och prognosdata. Kontrollera din anslutning och försök igen.",
    "home.model.production": "Standardprognos",
    "home.model.short": "Prognos",
    "home.model.title": "Prognosmodell",
    "home.model.productionDesc": "Vår ordinarie prognos, baserad på prishistoriken i elområdet",
    "home.model.pro": "Pro-prognos",
    "home.model.proDesc": "Andra modell som också väger in vind- och solprognoser i Nordeuropa",
    "home.model.proLocked": "Ingår i Premium. Uppgradera för att jämföra med standardprognosen",
    "navbar.country": "Land",
    "currency.title": "Valuta",
    "currency.SEK": "Svenska kronor",
    "currency.EUR": "Euro (cent)",
    "currency.NOK": "Norska kronor",
    "currency.DKK": "Danska kronor",
    "currency.source": "ECB:s referenskurser, {date}",
    "country.SE": "Sverige",
    "country.NO": "Norge",
    "country.FI": "Finland",
    "country.DK": "Danmark",
    "home.retry": "Försök igen",

    "commodity.selector": "Råvara",
    "commodity.electricity": "El",
    "commodity.copper": "Koppar",
    "commodity.crude": "Råolja",
    "commodity.section.electricity": "Elektricitet",
    "commodity.section.commodities": "Råvaror",

    "ai.title": "AI-analys och sammanfattning",
    "ai.promptPlaceholder": "Instruktioner...",
    "ai.analyze": "Analysera",
    "ai.ask": "Fråga",
    "ai.save": "Spara",
    "ai.saving": "Sparar...",
    "ai.cancel": "Avbryt",
    "signals.title": "Marknadshändelser",
    "signals.summaryTitle": "Nuläges-summering",
    "signals.summaryEmpty": "Ingen sammanfattning ännu.",
    "signals.updated": "Uppdaterad {ago}",
    "signals.empty": "Inga händelser att visa ännu.",
    "signals.loading": "Laddar händelser…",
    "signals.bullish": "Prishöjande",
    "signals.bearish": "Prissänkande",
    "signals.neutral": "Neutral påverkan",
    "signals.sources": "Källor:",
    "signals.sourceFallback": "Källa",
    "signals.readOriginal": "Läs originalet",
    "signals.event": "Händelse",
    "signals.published": "Publicerad",
    "signals.showMore": "Visa fler",
    "signals.showLess": "Visa färre",
    "ai.followUpPlaceholder": "Skriv uppföljning...",
    "ai.savedAnalyses": "Sparade analyser",
    "ai.newConversation": "Ny konversation",
    "ai.summarizeResults": "Sammanfatta resultat",
    "ai.loading": "AI arbetar...",
    "ai.empty": "Inga AI-svar ännu.",
    "ai.untitled": "Utan titel",
    "ai.noSavedConversations": "Inga sparade konversationer ännu.",
    "ai.conversations": "Konversationer",
    "ai.selectConversation": "Välj en konversation för att visa den",
    "ai.startNewOrSelect":
      "Starta en ny analys eller välj en sparad konversation",
    "ai.you": "Du",
    "ai.assistant": "Assistent",
    "ai.confirmDelete":
      "Är du säker på att du vill ta bort denna konversation?",
    "ai.delete": "Ta bort",

    "current.title": "Historiskt elpris",
    "current.title.copper": "Historiskt kopparpris",
    "current.title.crude": "Historiskt oljepris",
    "current.loading": "Laddar...",
    "current.unit": "kr/kWh",
    "current.viewToday": "Idag",
    "current.viewTodayTomorrow": "Idag + imorgon",
    "current.viewWeek": "7 dagar",
    "current.viewMonth": "30 dagar",
    "current.expand": "Expandera",
    "home.historicalPrices": "Historiska priser",

    "chart.title.static": "Elprisprognos {range}",
    "chart.title.dynamic": "Elprisprognos {range}",
    "chart.title.static.copper": "Kopparprognos {range}",
    "chart.title.static.crude": "Oljeprognos {range}",
    "chart.resetZoom": "Återställ zoom",
    "chart.predictionFrom": "Prognos från:",
    "chart.available": "{index} av {total} tillgängliga prognoser",
    "chart.selectArea": "Välj område",
    "chart.areaAll": "Alla",
    "chart.weather": "Väderprognos",
    "chart.trend": "Trend",
    "chart.weighting": "Viktning: {weather}% väder, {trend}% trend",
    "chart.actualPrices": "Faktiska priser",
    "chart.forecast": "Prognos",
    "chart.predictionWeighting": "Viktning av prognoser",
    "chart.news": "Nyheter",
    "chart.regression": "Trend",
    "chart.addPrediction": "Lägg till prognos",
    "chart.cancelPrediction": "Avbryt",
    "chart.userPredictions": "Mina prognoser",
    "chart.predictionMode": "Klicka på grafen för att placera en prognos",
    "chart.confirmPrediction": "Bekräfta prognos",
    "chart.predictionValue": "Värde",
    "chart.predictionTime": "Tidpunkt",
    "chart.savePrediction": "Spara",
    "chart.cancel": "Avbryt",
    "chart.predictionReasoning": "Prognosanalys",
    "chart.reasoningHint":
      "Stjärnmärkta punkter har analys - klicka för att se",
    "chart.reasoningPlaceholder": "Ange din analys för denna prognos...",
    "chart.reasoningRequired": "Analys är obligatorisk för alla prognoser",
    "chart.userPrediction": "Användarprognos",
    "chart.forecastDate": "Prognosdatum",
    "chart.forecastHour": "Timme",
    "chart.pinchToZoom": "Nyp för att zooma",
    "chart.zoomHint": "Ctrl+scroll eller dra för att zooma",
    "chart.forecastDetails": "Om prognosen",
    "chart.generated": "Skapad",
    "chart.horizon": "Tidsram",
    "chart.methods": "Metoder",
    "chart.hoursAhead": "{count} h framåt",
    "chart.daysAhead": "{count} dagar framåt",
    "chart.forecastRange": "Prognoslängd",
    "chart.range7d": "7 dagar",
    "chart.range30d": "30 dagar",
    "chart.justNow": "nyss",
    "chart.minutesAgo": "{count} minuter sedan",
    "chart.hoursAgo": "{count} timmar sedan",
    "chart.daysAgo": "{count} dagar sedan",

    "login.banner": "Logga in på Spotprisprognos",
    "login.welcome": "Välkommen tillbaka",
    "login.email": "E-post",
    "login.password": "Lösenord",
    "login.button": "Logga in",
    "login.noAccount": "Har du inget konto?",
    "login.registerLink": "Registrera dig här",
    "login.permissionsChanged":
      "Dina behörigheter har uppdaterats. Vänligen logga in igen.",
    "login.incorrectCredentials": "Felaktig e-post eller lösenord.",

    "register.banner": "Kom igång med Spotprisprognos",
    "register.welcome": "Skapa ditt konto",
    "register.username": "Användarnamn",
    "register.email": "E-post",
    "register.password": "Lösenord",
    "register.confirmPassword": "Bekräfta lösenord",
    "register.button": "Registrera",
    "register.hasAccount": "Har du redan ett konto?",
    "register.loginLink": "Logga in här",
    "register.checkEmailTitle": "Kontrollera din e-post",
    "register.successMessagePrefix": "Ett verifieringsmail har skickats till",
    "register.successMessageSuffix":
      ". Kontrollera din inkorg och klicka på verifieringslänken för att aktivera ditt konto.",
    "register.goToLogin": "Gå till inloggning",
    "register.emailExists":
      "Det finns redan ett konto med den här e-postadressen. Prova att logga in istället.",
    "register.genericError": "Något gick fel vid registreringen. Försök igen.",
    "register.privacyPrefix":
      "När du skapar ett konto behandlar vi dina personuppgifter enligt vår",
    "register.privacyLink": "integritetspolicy",

    "emailVerification.banner": "E-postverifiering",
    "emailVerification.successTitle": "Tack!",
    "emailVerification.successMessage":
      "Din e-postadress har verifierats. Du kan nu logga in.",
    "emailVerification.goToLogin": "Gå till inloggning",
    "emailVerification.errorTitle": "Verifiering misslyckades",
    "emailVerification.tokenExpired":
      "Verifieringslänken har gått ut. Begär en ny länk nedan.",
    "emailVerification.tokenNotFound":
      "Verifieringslänken är ogiltig eller har redan använts.",
    "emailVerification.invalidToken": "Ogiltig verifieringslänk.",
    "emailVerification.genericError":
      "Ett fel uppstod vid verifiering av din e-post.",
    "emailVerification.resendTitle": "Skicka ny verifieringslänk",
    "emailVerification.emailPlaceholder": "Din e-postadress",
    "emailVerification.emailRequired": "E-postadress krävs",
    "emailVerification.resendButton": "Skicka ny länk",
    "emailVerification.sending": "Skickar...",
    "emailVerification.resendSuccess":
      "Om ett konto med denna e-postadress finns har vi skickat en ny verifieringslänk.",
    "emailVerification.resendFailed":
      "Det gick inte att skicka verifieringsmail. Försök igen.",
    "emailVerification.alreadyVerified":
      "Denna e-postadress är redan verifierad.",
    "emailVerification.backToLogin": "Tillbaka till inloggning",
    "login.emailNotVerified":
      "Din e-postadress är inte verifierad. Kontrollera din e-post eller begär en ny verifieringslänk.",
    "login.resendVerification": "Skicka ny verifieringslänk",
    "login.verificationResent":
      "Verifieringslänk skickad! Kontrollera din e-post för att aktivera ditt konto.",

    "common.ok": "OK",

    "users.title": "Användare",
    "users.subtitle": "Upptäck och följ andra handlare",
    "users.search": "Sök användare...",
    "users.loading": "Laddar användare...",
    "users.empty": "Inga användare hittades.",
    "users.viewProfile": "Visa profil",
    "users.predictions": "prognoser",
    "users.topUsers": "Topanvändare",
    "users.latestPredictions": "Senaste prognoser",
    "users.noAccess": "Du har inte behörighet att visa användare. Kontakta en administratör för att få åtkomst.",


    "account.title": "Mitt konto",
    "account.subtitle": "Hantera din profil och inställningar",
    "account.apiDocsButton": "Dokumentation",
    "account.apiDocsTitle": "API-dokumentation",
    "account.apiDocsIntro": "Alla endpoints kräver headern",
    "account.apiDocsBaseUrl": "Bas-URL",
    "account.apiDocsRateLimit": "Standardgräns: 1 000 anrop/timme per nyckel. Kontakta admin om du behöver mer.",
    "account.apiDocsParam": "Parameter",
    "account.apiDocsRequired": "Obligatorisk",
    "account.apiDocsExample": "Exempel",
    "account.apiDocsDescription": "Beskrivning",
    "account.apiDocsYes": "Ja",
    "account.apiDocsNo": "Nej",
    "account.apiDocsCopy": "Kopiera",
    "account.apiDocsCopied": "Kopierat!",
    "account.apiDocsHasAccess": "Åtkomst",
    "account.apiDocsNoAccess": "Ingen åtkomst",
    "account.apiDocsContactAdmin": "Du har inte åtkomst till den här endpointen. Kontakta en administratör för att få åtkomst.",
    "account.apiDocsUpgradePremium": "Den här endpointen ingår i Premium. Uppgradera ditt konto för att få åtkomst.",
    "account.settings": "Profilinställningar",
    "account.profileImage": "Profilbild",
    "account.changeImage": "Ändra bild",
    "account.username": "Användarnamn",
    "account.usernamePlaceholder": "Ange användarnamn",
    "account.email": "E-post",
    "account.save": "Spara",
    "account.cancel": "Avbryt",
    "account.edit": "Redigera",
    "account.predictions": "Prognoser",
    "account.myPredictions": "Mina prognoser",
    "account.noPredictions": "Du har inga prognoser ännu.",
    "account.loading": "Laddar...",
    "account.notFound": "Kontot hittades inte.",
    "account.imageUrl": "Bild-URL",
    "account.imageUrlHint": "Ange en URL till din profilbild",
    "account.viewAnalysis": "Visa analys",
    "account.predicted": "Förutsagt",
    "account.analysis": "Analys",
    "account.close": "Stäng",

    "navbar.admin": "Administration",

    "admin.title": "Administration",
    "admin.subtitle": "Hantera användare och roller",
    "admin.searchUsers": "Sök användare...",
    "admin.users": "Användare",
    "admin.usersCount": "användare",
    "admin.sortUsers": "Sortera användare",
    "admin.sortNewest": "Nyast först",
    "admin.sortActive": "Senast aktiv",
    "admin.sortName": "E-post A–Ö",
    "admin.userCreated": "Skapad",
    "admin.userLastLogin": "Senast inloggad",
    "admin.userLastSeen": "Senast aktiv",
    "admin.availableRoles": "Tillgängliga roller",
    "admin.editRoles": "Redigera roller",
    "admin.editRolesFor": "Redigera roller för",
    "admin.selectRoles": "Välj vilka roller användaren ska ha:",
    "admin.noRoles": "Inga roller",
    "admin.cancel": "Avbryt",
    "admin.saving": "Sparar...",
    "admin.saveChanges": "Spara ändringar",
    "admin.roleDescriptions.admin": "Full administrativ åtkomst",
    "admin.roleDescriptions.premium": "Åtkomst till alla resurser",
    "admin.roleDescriptions.basic": "Åtkomst till el och dokument",
    "admin.roleDescriptions.free": "Endast elpriser",
    "admin.rolesTab": "Roller",
    "admin.permissionsTab": "Behörigheter",
    "admin.settingsTab": "Inställningar",
    "admin.insightsTab": "Användarinsikter",
    "admin.analyticsLink": "Prognosnoggrannhet",
    "admin.upgradesTab": "Plan-uppgraderingar",
    "admin.upgradesTitle": "Väntande uppgraderingar",
    "admin.upgradesEmpty": "Inga väntande uppgraderingar.",
    "admin.upgradesUser": "Användare",
    "admin.upgradesCurrent": "Nuvarande",
    "admin.upgradesRequested": "Önskar",
    "admin.upgradesWhen": "Begärd",
    "admin.upgradesAction": "Åtgärd",
    "admin.upgradesApprove": "Godkänn",
    "admin.upgradesReject": "Avvisa",
    "admin.upgradeApproved": "Uppgradering godkänd.",
    "admin.upgradeRejected": "Uppgradering avvisad.",
    "admin.createRole": "Skapa roll",
    "admin.editPermissions": "Redigera behörigheter",
    "admin.editPermissionsFor": "Redigera behörigheter för",
    "admin.deleteRole": "Ta bort roll",
    "admin.permissionsCount": "behörigheter",
    "admin.noPermissions": "Inga behörigheter",
    "admin.allPermissions": "Alla behörigheter",
    "admin.selectPermissions": "Välj vilka behörigheter rollen ska ha:",
    "admin.roleName": "Rollnamn",
    "admin.roleNamePlaceholder": "Ange rollnamn...",

    "admin.success.rolesUpdated": "Roller uppdaterade",
    "admin.success.roleCreated": "Roll skapad",
    "admin.success.roleDeleted": "Roll borttagen",
    "admin.success.permissionsUpdated": "Behörigheter uppdaterade",
    "admin.success.planCreated": "Plan skapad",
    "admin.success.planUpdated": "Plan uppdaterad",
    "admin.success.planDeleted": "Plan borttagen",
    "admin.success.planAssigned": "Plan tilldelad",
    "admin.success.settingUpdated": "Inställning uppdaterad",
    "admin.success.userDeleted": "Användare borttagen",
    "admin.deleteUser": "Ta bort användare",
    "admin.confirmDeleteUser": "Är du säker på att du vill ta bort denna användare? All data raderas permanent.",
    "account.deleteAccount": "Ta bort konto",
    "account.confirmDeleteAccount": "Är du säker på att du vill ta bort ditt konto? All din data raderas permanent och detta kan inte ångras.",
    "account.accountDeleted": "Kontot har tagits bort",

    "admin.plans": "Planer",
    "admin.createPlan": "Skapa plan",
    "admin.editPlan": "Redigera plan",
    "admin.deletePlan": "Ta bort plan",
    "admin.planName": "Plannamn",
    "admin.planDescription": "Beskrivning",
    "admin.planRoles": "Roller i planen",
    "admin.planPrice": "Pris",
    "admin.planPerMonth": "mån",
    "admin.planFree": "Gratis",
    "admin.planActiveDays": "Aktiva dagar",
    "admin.planDaysPerMonth": "dagar/mån",
    "admin.planUnlimited": "Obegränsat",
    "admin.planApiRequests": "API-anrop",
    "admin.planMaxActiveDays": "Max aktiva dagar / månad",
    "admin.planMaxActiveDaysHint": "Lämna tomt för obegränsat. Annars stoppas användaren efter X aktiva dagar i månaden.",
    "admin.planApiMonthly": "API-anrop / månad",
    "admin.planApiMonthlyHint": "Lämna tomt för ingen API-åtkomst alls. Annars max så här många anrop per kalendermånad.",
    "admin.planApiRpm": "API-anrop / minut",
    "admin.planApiRpmHint": "Lämna tomt för inget tak per minut (gäller endast om månadskvoten är satt).",
    "admin.planIsHidden": "Dold (endast admin-tilldelad)",
    "admin.planIsHiddenHint": "Dolda planer (t.ex. Admin/Superadmin) visas inte i användarens planbytesmeny.",
    "admin.planIsInternal": "Intern (endast admin-tilldelad)",
    "admin.planIsInternalHint": "Interna planer (t.ex. Admin/Superadmin) visas aldrig på prissidan eller i användarens planbytesmeny.",
    "admin.planInternalBadge": "Intern",
    "admin.planPriceSek": "Pris (kr/mån)",
    "admin.planPriceSekHint": "Visas på den publika prissidan. Lämna tomt om planen är gratis eller intern.",
    "admin.planNoPricePlaceholder": "Inget pris",
    "pricing.title": "Priser",
    "pricing.subtitle": "Välj en plan som passar dig. Uppgradera eller nedgradera när som helst.",
    "pricing.month": "mån",
    "pricing.free": "Gratis",
    "pricing.cta": "Kom igång",
    "pricing.back": "Tillbaka",
    "admin.planUnlimitedPlaceholder": "Obegränsat",
    "admin.planNoAccessPlaceholder": "Ingen åtkomst",
    "admin.planNoRpmPlaceholder": "Inget tak",
    "admin.planMoveUp": "Flytta upp",
    "admin.planMoveDown": "Flytta ner",
    "admin.planDragHint": "Dra för att ändra ordning",
    "admin.planNameRequired": "Plannamn krävs.",
    "admin.planSaveFailed": "Kunde inte spara planen.",
    "admin.defaultSignupPlan": "Standardplan vid registrering",
    "admin.defaultPlanHint": "Nya användare tilldelas automatiskt denna plan vid registrering.",
    "admin.noDefaultPlan": "Ingen (ingen plan tilldelas)",
    "admin.assignPlan": "Tilldela plan",
    "admin.changePlan": "Byt plan",
    "admin.userPlan": "Plan",
    "admin.noPlan": "Ingen plan",
    "admin.planUsers": "användare",
    "admin.planNamePlaceholder": "Ange plannamn...",
    "admin.planDescriptionPlaceholder": "Beskriv planen...",
    "admin.confirmDeletePlan": "Är du säker på att du vill ta bort planen",
    "admin.noPlans": "Inga planer skapade ännu.",
    "admin.planRolesCount": "roller",
    "account.planLabel": "Prenumeration",
    "account.planNone": "Ingen plan",
    "account.planUpgrade": "Uppgradera",
    "account.planChange": "Byt plan",
    "account.planRequestUpgrade": "Skicka förfrågan",
    "account.planUpgradeIntro": "Välj vilken plan du vill uppgradera till. En administratör måste godkänna förfrågan innan den träder i kraft.",
    "account.planChangeIntro": "Välj vilken plan du vill byta till. En administratör måste godkänna förfrågan innan den träder i kraft.",
    "account.planUpgradeApprovalNote": "Förfrågan behöver godkännas av en administratör. Du behåller din nuvarande plan tills dess.",
    "account.planChangeApprovalNote": "Förfrågan behöver godkännas av en administratör. Du behåller din nuvarande plan tills dess.",
    "account.planPendingRequest": "Du har redan en väntande förfrågan om planbyte. En administratör granskar den.",
    "account.planTopTier": "Det finns inga andra planer att byta till just nu.",
    "account.planManagedManually": "Din plan är tilldelad manuellt — Du har redan behörighet till alla funktioner.",
    "account.planCheckoutNote": "Du skickas vidare till Stripe för att slutföra betalningen. Planen aktiveras direkt efter betalning.",
    "account.planTermsPrefix": "Genom att fortsätta godkänner du våra",
    "account.planTermsLink": "köpvillkor",
    "account.planContinueToPayment": "Fortsätt till betalning",
    "account.planSwitchNote": "Du skickas till Stripe för att bekräfta planbytet. Bytet sker direkt: vid uppgradering dras mellanskillnaden nu, vid nedgradering tillgodoräknas den på nästa faktura.",
    "account.planContinueToSwitch": "Fortsätt till planbyte",
    "account.planCancelNote": "Du skickas till Stripe för att avsluta din prenumeration. Du behåller din nuvarande plan till slutet av betalperioden, därefter flyttas du till Free.",
    "account.planContinueToCancel": "Fortsätt till avslut",
    "account.planCancellationPending": "Din prenumeration avslutas {date}. Därefter flyttas du till Free-planen.",
    "account.planResumeSubscription": "Ångra avslut",
    "account.manageSubscription": "Hantera prenumeration",
    "billing.activatingTitle": "Aktiverar din prenumeration …",
    "billing.activatingBody": "Vänta ett ögonblick medan vi bekräftar din betalning.",
    "billing.successTitle": "Tack! Din prenumeration är aktiv.",
    "billing.successBody": "Din nya plan är nu aktiverad.",
    "billing.pendingTitle": "Betalningen behandlas",
    "billing.pendingBody": "Det kan ta en stund. Din plan uppdateras automatiskt när betalningen är klar.",
    "billing.cancelledTitle": "Betalningen avbröts",
    "billing.cancelledBody": "Inga ändringar gjordes. Du kan försöka igen när du vill.",
    "billing.backToAccount": "Tillbaka till kontot",

    "navbar.analytics": "Analys",
    "analytics.title": "Prognosnoggrannhet",
    "analytics.subtitle": "Validering och precision per metod, område och tidsperiod.",
    "analytics.forecastVsActual": "Prognos mot utfall",
    "navbar.articles": "Artiklar",
    "articles.title": "Artiklar",
    "articles.beta": "Test · bara admin",
    "articles.subtitle": "Längre analyser av elmarknaden, en gång i månaden, skrivna utifrån våra egna data.",
    "articles.kicker": "Månadens analys",
    "articles.byline": "Spotprisprognos",
    "articles.minutes": "{count} min läsning",
    "articles.empty": "Inga publicerade artiklar ännu.",
    "articles.noAccess": "Artiklar är bara tillgängliga för administratörer än så länge.",
    "articles.loadError": "Artiklarna kunde inte laddas.",
    "articles.notFound": "Artikeln finns inte eller är inte publicerad.",
    "articles.adminOnly": "Syns bara för administratörer",
    "articles.status.draft": "Utkast",
    "articles.status.published": "Publicerad",
    "articles.status.removed": "Borttagen",
    "articles.publish": "Publicera",
    "articles.unpublish": "Avpublicera",
    "articles.remove": "Ta bort",
    "articles.deleteForever": "Radera permanent",
    "articles.confirmRemove": "Ta bort \"{title}\"? Den försvinner från listan men kan återställas.",
    "articles.confirmDelete": "Radera \"{title}\" permanent? Det går inte att ångra.",
    "articles.coverCaption": "Illustration: AI-genererad (Mistral)",
    "articles.disclosure": "Texten är skriven av en AI-modell (Mistral Large) utifrån Spotprisprognos egna data om priser, produktion och nyheter, och granskad innan publicering. Den är inte finansiell rådgivning.",
    "articles.sources": "Underlag",
    "articles.link": "Länk",
    "articles.adminTitle": "Artiklar",
    "articles.adminSub": "Laddas upp som utkast av scripts/generate_article.py",
    "articles.adminEmpty": "Inga artiklar uppladdade ännu.",
    "articles.colTitle": "Rubrik",
    "articles.colStatus": "Status",
    "articles.colCreated": "Uppladdad",
    "articles.colPublished": "Publicerad",
    "articles.colWords": "Ord",
    "models.title": "Modelljämförelse",
    "models.standard": "Standard",
    "models.pro": "Pro",
    "models.naive": "Naiv (förra veckan)",
    "models.naiveDesc": "Priset samma timme en eller flera hela veckor före prognosen, det som var känt när prognosen gjordes. En modell ska slå detta.",
    "models.unit": "öre/kWh",
    "models.scope": "Zoner",
    "models.allZones": "Alla zoner",
    "models.wholeCountry": "Hela {country}",
    "models.period": "Period",
    "models.anchor": "Prognostidpunkt",
    "models.anchorAt": "Prognos från kl {hour} UTC",
    "models.overlap": "Bara gemensamma timmar",
    "models.hint": "En prognos per modell, zon och dag (den första efter vald tidpunkt) jämförs timme för timme med det faktiska spotpriset. Med \"bara gemensamma timmar\" räknas bara timmar som båda modellerna har prognos för.",
    "models.error": "Modelljämförelsen kunde inte laddas.",
    "models.best": "Bäst",
    "models.noRows": "Inga prognoser i perioden.",
    "models.mae": "MAE",
    "models.rmse": "RMSE",
    "models.bias": "Bias",
    "models.skill": "Skill",
    "models.vsNaive": "mot naiv",
    "models.cheap3": "Billigaste 3 h",
    "models.days": "{count} dygn",
    "models.hours": "Timmar",
    "models.scored": "jämförda",
    "models.byLead": "Fel per prognoshorisont",
    "models.byLeadSub": "MAE per dag framåt från prognosen",
    "models.lead": "Horisont",
    "models.leadDays": "{range} dygn",
    "models.trend": "Fel över tid",
    "models.trendSub": "MAE för de närmaste 48 timmarna, per prognosdag",
    "models.perZone": "Per zon",
    "models.zone": "Zon",
    "analytics.noData": "Ingen data tillgänglig för vald period.",
    "analytics.electricity": "El",
    "analytics.commodities": "Råvaror",
    "analytics.allTargets": "Alla",
    "analytics.days": "dagar",
    "analytics.lastDays": "Senaste {count} dagar",
    "analytics.totalValidated": "Validerade prognoser",
    "analytics.avgAccuracy": "Genomsnittlig precision",
    "analytics.directionAccuracy": "Riktningsprecision",
    "analytics.bestMethod": "Bästa metod",
    "analytics.methodComparison": "Metodjamforelse",
    "analytics.method": "Metod",
    "analytics.method.weather": "Vader",
    "analytics.method.regression": "Regression",
    "analytics.method.news": "Nyheter",
    "analytics.method.user": "Användare",
    "analytics.predictions": "Prognoser",
    "analytics.avgScore": "Medelpoäng",
    "analytics.avgDistance": "Medelavvikelse",
    "analytics.direction": "Riktning",
    "analytics.bestScore": "Bästa",
    "analytics.worstScore": "Sämsta",
    "analytics.accuracyOverTime": "Precision över tid",
    "analytics.predictionDetails": "Prognosdetaljer",
    "analytics.total": "totalt",
    "analytics.targetTime": "Måltid",
    "analytics.generatedAt": "Skapad",
    "analytics.predicted": "Prognos",
    "analytics.distance": "Avvikelse",
    "analytics.score": "Poäng",
    "analytics.type": "Typ",
    "analytics.viewReasoning": "Visa analys",
    "analytics.reasoning": "Analys",
    "analytics.userLeaderboard": "Användartopplista",
    "analytics.user": "Användare",
    "analytics.anonymous": "Anonym",
    "analytics.allTypes": "Alla typer",
    "analytics.filter": "Filtrera",
    "analytics.customRange": "Anpassat",
    "analytics.startDate": "Från",
    "analytics.endDate": "Till",
    "analytics.actual": "Faktiskt",
    "analytics.noValidation": "Ingen validering tillgänglig ännu för denna period.",
    "analytics.timelineMetric": "Mätvärde",
    "analytics.userActivity": "Användaraktivitet",
    "analytics.noActivity": "Ingen aktivitet i den här perioden.",
    "analytics.noEvents": "Inga händelser för den här användaren.",
    "analytics.activeDays": "Aktiva dagar",
    "analytics.activeDaysMonth": "Aktiva dagar / månad",
    "analytics.apiCallsMonth": "API-anrop / månad",
    "analytics.plan": "Plan",
    "analytics.pageViews": "Sidvisningar",
    "analytics.areaToggles": "Områdesval",
    "analytics.ctaClicks": "CTA-klick",
    "analytics.modalOpens": "Modaler",
    "analytics.lastActive": "Senast aktiv",
    "analytics.event": "Händelse",
    "analytics.target": "Mål",
    "analytics.when": "Tidpunkt",
  },
  en: {
    "navbar.language": "Language",
    "navbar.darkMode": "Dark mode",
    "navbar.overview": "Overview",
    "navbar.map": "Map",
    "navbar.forum": "Forum",
    "admin.forum.overviewTitle": "Moderator overview",
    "admin.forum.overviewLead": "What needs attention. Moderate directly in the forum through each post's menu (…).",
    "admin.forum.toForum": "Go to forum",
    "admin.forum.open": "Open",
    "admin.forum.openReports": "Open reports",
    "admin.forum.hiddenPosts": "Hidden posts",
    "admin.forum.hiddenThreads": "{n} hidden threads",
    "admin.forum.bannedMembers": "Banned",
    "admin.forum.postsWeek": "Posts, 7 days",
    "admin.forum.postsDay": "{n} in the last day",
    "admin.forum.threadsWeek": "New threads, 7 days",
    "admin.forum.newMembers": "{n} new posters",
    "admin.forum.reports": "Reported posts",
    "admin.forum.noReports": "No open reports.",
    "admin.forum.reportCount": "{n} reports",
    "admin.forum.report1": "1 report",
    "admin.forum.alreadyHidden": "already hidden",
    "admin.forum.hiddenTitle": "Hidden posts",
    "admin.forum.noHidden": "No hidden posts.",
    "admin.forum.hiddenBy": "hidden by {name} {date}",
    "admin.forum.bannedTitle": "Banned members",
    "admin.forum.noBanned": "No banned members.",
    "admin.forum.bannedSince": "banned {date}",
    "admin.forum.postCount": "{n} posts",
    "admin.forum.latestPost": "Latest post",
    "admin.forum.editedTitle": "Recently edited posts",
    "admin.forum.editedLead": "Edited after posting, last 14 days. The version history is in the post's menu.",
    "admin.forum.noEdited": "No edited posts.",
    "admin.forum.editedMeta": "edited {date} · {n} earlier versions",
    "forum.mod.banned": "Banned",
    "forum.mod.reports": "{n} reports",
    "forum.mod.report1": "1 report",
    "forum.mod.showReports": "Show reports",
    "forum.mod.dismissReports": "Dismiss reports",
    "forum.mod.noReason": "no reason given",
    "forum.mod.noReports": "No open reports.",
    "forum.mod.rename": "Rename member",
    "forum.mod.renamePrompt": "New forum name for {name}:",
    "forum.mod.ban": "Ban from forum",
    "forum.mod.unban": "Lift ban",
    "forum.mod.banConfirm": "Ban {name} from the forum? They can read but not post or vote.",
    "forum.mod.unbanConfirm": "Lift the ban for {name}?",
    "forum.mod.createDaily": "Create daily thread",
    "forum.mod.rebuildDaily": "Update with latest forecast",
    "forum.mod.dailyResult": "Daily thread for {date}: {status}",
    "forum.mod.status.created": "created",
    "forum.mod.status.updated": "updated",
    "forum.mod.status.exists": "already exists",
    "forum.mod.status.waiting": "waiting for prices",
    "forum.mod.status.no-data": "no data yet",
    "forum.mode.write": "Write",
    "forum.mode.preview": "Preview",
    "forum.mode.split": "Side by side",
    "forum.fmt.codeBlock": "Code block",
    "forum.fmt.plainCode": "Other / text",
    "forum.daily.outlookTitle": "Our forecast {from} – {to}",
    "forum.daily.cheapestDay": "Cheapest day",
    "forum.daily.forecastMean": "{value} per kWh on average, forecast",
    "forum.daily.knownTitle": "Tomorrow, {date}: already set",
    "forum.daily.tomorrowKnown": "Tomorrow (set)",
    "forum.daily.weSaid": "we forecast",
    "forum.nameLockNote": "Your name can't be changed after your first post, so choose carefully.",
    "forum.memberSince": "Forum name is locked after the first post",
    "forum.eyebrow": "Community",
    "forum.write": "Write",
    "forum.preview": "Preview",
    "forum.previewEmpty": "Nothing to preview yet.",
    "forum.fmt.bold": "Bold",
    "forum.fmt.boldText": "bold text",
    "forum.fmt.italic": "Italic",
    "forum.fmt.italicText": "italic text",
    "forum.fmt.quote": "Quote",
    "forum.fmt.list": "Bulleted list",
    "forum.fmt.code": "Code",
    "forum.fmt.link": "Link",
    "forum.fmt.linkText": "link text",
    "forum.fmt.hint": "**bold**, *italic*, > quote, - list, ```yaml for code blocks · Tab indents · Ctrl+Enter sends",
    "forum.dailyAvg": "daily mean",
    "forum.dailyForecastAvg": "forecast, daily mean",
    "forum.vsForecast": "Vs forecast",
    "forum.joinDiscussion": "Discuss",
    "forum.votes": "Votes",
    "forum.statThreads": "threads",
    "forum.statPosts": "posts",
    "forum.statMembers": "members",
    "forum.statToday": "in the last day",
    "forum.statViews": "views",
    "forum.searchPlaceholder": "Search the forum…",
    "forum.allThreads": "All threads",
    "forum.sort.active": "Active",
    "forum.sort.new": "New",
    "forum.sort.top": "Top",
    "forum.searchResults": "Results for “{q}”",
    "forum.noResults": "No threads match your search.",
    "forum.modPanel": "Moderation",
    "forum.joinTitle": "Join the conversation",
    "forum.joinLead": "Pick a forum name to start threads, reply and vote.",
    "forum.topMembers": "Most active (30 days)",
    "forum.rulesTitle": "Forum rules",
    "forum.rule1": "Be kind. Criticise ideas, not people.",
    "forum.rule2": "No personal data, not even your own.",
    "forum.rule3": "No ads or spam. Product tips are fine.",
    "forum.rule4": "Report posts that break the rules and a moderator will look at them.",
    "forum.moderator": "Moderator",
    "forum.op": "Original poster",
    "forum.replyingTo": "Reply to {name}",
    "forum.editNote": "Earlier versions are kept and visible to moderators.",
    "forum.ownPost": "You can't vote on your own post",
    "forum.upvote": "Upvote",
    "forum.share": "Share",
    "forum.linkCopied": "Link copied.",
    "forum.more": "More",
    "forum.history": "Version history ({n})",
    "forum.modRename": "Rename",
    "forum.modHideThread": "Hide thread",
    "forum.modMove": "Move to",
    "forum.replyAs": "Replying as",
    "forum.aboutThread": "About this thread",
    "forum.started": "Started",
    "forum.lastActivity": "Last activity",
    "forum.repliesLabel": "Replies",
    "forum.viewsLabel": "Views",
    "forum.participants": "Participants",
    "forum.copyLink": "Copy link",
    "forum.historyTitle": "Version history",
    "forum.currentVersion": "Current version",
    "forum.replacedAt": "Replaced {date}",
    "forum.newLead": "Ask a question, share a solution or start a discussion. Threads are public.",
    "forum.titlePlaceholder": "What do you want to discuss?",
    "forum.bodyPlaceholder": "Tell us more. The more concrete, the better the answers.",
    "forum.tipsTitle": "Tips for a good thread",
    "forum.tip1": "Write a title that says what the thread is about.",
    "forum.tip2": "Mention your zone and setup (battery, heat pump, EV) if it matters.",
    "forum.tip3": "Search first, the answer may already be here.",
    "forum.formatTitle": "Formatting",

    "forum.title": "Forum",
    "forum.lead": "Discuss electricity prices, forecasts, batteries and automation with other users. Threads are public and also shown on spotprisprognos.se.",
    "forum.daily": "Today's thread",
    "forum.dailyOpen": "Open thread",
    "forum.categories": "Categories",
    "forum.latest": "Latest threads",
    "forum.threads": "{n} threads",
    "forum.thread1": "1 thread",
    "forum.replies": "{n} replies",
    "forum.reply1": "1 reply",
    "forum.noThreads": "No threads yet. Start the first one!",
    "forum.newThread": "New thread",
    "forum.loadMore": "Show more",
    "forum.back": "Forum",
    "forum.pinned": "Pinned",
    "forum.locked": "Locked",
    "forum.hiddenThread": "Hidden",
    "forum.staff": "Team",
    "forum.bot": "Automatic",
    "forum.edited": "edited",
    "forum.deletedPost": "This post was deleted by its author.",
    "forum.hiddenPost": "This post was hidden by a moderator.",
    "forum.reply": "Reply",
    "forum.replyPlaceholder": "Write a reply…",
    "forum.send": "Send",
    "forum.sending": "Sending…",
    "forum.edit": "Edit",
    "forum.save": "Save",
    "forum.cancel": "Cancel",
    "forum.delete": "Delete",
    "forum.deleteConfirm": "Delete this post? Its text is erased.",
    "forum.report": "Report",
    "forum.reportPrompt": "Why are you reporting this post? (optional)",
    "forum.reported": "Thanks, a moderator will take a look.",
    "forum.lockedNotice": "This thread is locked for new replies.",
    "forum.bannedNotice": "Your account can't post in the forum.",
    "forum.publicNotice": "Posts are public and shown under your forum name, also to visitors who aren't logged in.",
    "forum.notFound": "The thread doesn't exist or has been removed.",
    "forum.loadError": "Couldn't load the forum.",
    "forum.category": "Category",
    "forum.threadTitle": "Title",
    "forum.threadBody": "Post",
    "forum.create": "Create thread",
    "forum.nameTitle": "Choose a forum name",
    "forum.nameLead": "Your forum name is shown publicly with your posts. Don't use your full name or e-mail if you want to stay anonymous.",
    "forum.nameLabel": "Forum name",
    "forum.nameHint": "3–24 characters: letters, digits, spaces, dot, hyphen or underscore.",
    "forum.nameSave": "Save name",
    "forum.yourName": "You post as {name}",
    "forum.changeName": "Change name",
    "forum.mod": "Moderate",
    "forum.modPin": "Pin",
    "forum.modUnpin": "Unpin",
    "forum.modLock": "Lock",
    "forum.modUnlock": "Unlock",
    "forum.modHide": "Hide",
    "forum.modShow": "Show",

    "forum.daily.final": "Spot prices {date}",
    "forum.daily.forecast": "Forecast {date} (spot prices not published yet)",
    "forum.daily.zone": "Zone",
    "forum.daily.avg": "Average",
    "forum.daily.min": "Lowest",
    "forum.daily.max": "Highest",
    "forum.daily.cheapest": "Cheapest 3 h",
    "forum.daily.ourForecast": "Our forecast before the auction",
    "forum.daily.outlook": "Forecast for the coming days (daily mean)",
    "forum.daily.hourly": "Hourly price",

    "admin.forumTab": "Forum",
    "navbar.configure": "Configure",
    "navbar.account": "My Account",
    "navbar.upgrade": "Upgrade",
    "navbar.logout": "Log out",

    "map.title": "Map – events & generation",
    "map.subtitle": "Spot price per bidding zone, market events and major generation assets. Drag the time slider to see past prices and the forecast ahead.",
    "map.play": "Play",
    "map.pause": "Pause",
    "map.now": "Now",
    "map.actual": "Spot price",
    "map.forecast": "Forecast",
    "map.timeline": "Choose time",
    "home.miniMap.title": "Bidding zones now",
    "home.miniMap.expand": "Open map",
    "map.loading": "Loading map…",
    "map.layerPrices": "Spot price per zone",
    "map.layerEvents": "Market events",
    "map.layerAssets": "Generation assets",
    "map.legendPrice": "Spot price (SEK/kWh)",
    "map.legendPriceTitle": "Spot price",
    "map.assetCapacity": "Installed capacity",
    "map.assetZone": "Bidding zone",
    "map.assetType.nuclear": "Nuclear",
    "map.assetType.hydro": "Hydropower",
    "map.assetType.wind": "Wind power",
    "map.assetType.thermal": "Thermal",

    "home.title": "Price Forecasts",
    "home.subtitle":
      "Electricity spot prices - real-time prices and price forecasts",
    "home.noAccess": "You do not have permission to view price data. Contact an administrator for access.",
    "home.loadError": "Couldn't load price and forecast data. Check your connection and try again.",
    "home.model.production": "Standard forecast",
    "home.model.short": "Forecast",
    "home.model.title": "Forecast model",
    "home.model.productionDesc": "Our regular forecast, from the bidding zone's price history",
    "home.model.pro": "Pro forecast",
    "home.model.proDesc": "A second model that also weighs in wind and solar forecasts across northern Europe",
    "home.model.proLocked": "Included in Premium. Upgrade to compare it with the standard forecast",
    "navbar.country": "Country",
    "currency.title": "Currency",
    "currency.SEK": "Swedish krona",
    "currency.EUR": "Euro (cents)",
    "currency.NOK": "Norwegian krone",
    "currency.DKK": "Danish krone",
    "currency.source": "ECB reference rates, {date}",
    "country.SE": "Sweden",
    "country.NO": "Norway",
    "country.FI": "Finland",
    "country.DK": "Denmark",
    "home.retry": "Try again",

    "commodity.selector": "Commodity",
    "commodity.electricity": "Electricity",
    "commodity.copper": "Copper",
    "commodity.crude": "Crude oil",
    "commodity.section.electricity": "Electricity",
    "commodity.section.commodities": "Commodities",

    "ai.title": "AI insights and summaries",
    "ai.promptPlaceholder": "Instructions...",
    "ai.analyze": "Analyze",
    "ai.ask": "Ask",
    "ai.save": "Save",
    "ai.saving": "Saving...",
    "ai.cancel": "Cancel",
    "signals.title": "Market events",
    "signals.summaryTitle": "Current outlook",
    "signals.summaryEmpty": "No summary yet.",
    "signals.updated": "Updated {ago}",
    "signals.empty": "No events to show yet.",
    "signals.loading": "Loading events…",
    "signals.bullish": "Price-raising",
    "signals.bearish": "Price-lowering",
    "signals.neutral": "Neutral impact",
    "signals.sources": "Sources:",
    "signals.sourceFallback": "Source",
    "signals.readOriginal": "Read the original",
    "signals.event": "Event",
    "signals.published": "Published",
    "signals.showMore": "Show more",
    "signals.showLess": "Show less",
    "ai.followUpPlaceholder": "Write follow-up...",
    "ai.savedAnalyses": "Saved analyses",
    "ai.newConversation": "New conversation",
    "ai.summarizeResults": "Summarize results",
    "ai.loading": "AI is working...",
    "ai.empty": "No AI responses yet.",
    "ai.untitled": "Untitled",
    "ai.noSavedConversations": "No saved conversations yet.",
    "ai.conversations": "Conversations",
    "ai.selectConversation": "Select a conversation to view",
    "ai.startNewOrSelect":
      "Start a new analysis or select a saved conversation",
    "ai.you": "You",
    "ai.assistant": "Assistant",
    "ai.confirmDelete": "Are you sure you want to delete this conversation?",
    "ai.delete": "Delete",

    "current.title": "Historical electricity price",
    "current.title.copper": "Historical copper price",
    "current.title.crude": "Historical crude oil price",
    "current.loading": "Loading...",
    "current.unit": "SEK/kWh",
    "current.viewToday": "Today",
    "current.viewTodayTomorrow": "Today + tomorrow",
    "current.viewWeek": "7 days",
    "current.viewMonth": "30 days",
    "current.expand": "Expand",
    "home.historicalPrices": "Historical prices",

    "chart.title.static": "Electricity price forecast — {range}",
    "chart.title.dynamic": "Electricity price forecast — {range}",
    "chart.title.static.copper": "Copper price forecast — {range}",
    "chart.title.static.crude": "Crude oil price forecast — {range}",
    "chart.resetZoom": "Reset zoom",
    "chart.predictionFrom": "Forecast from:",
    "chart.available": "{index} of {total} available forecasts",
    "chart.selectArea": "Select area",
    "chart.areaAll": "All",
    "chart.weather": "Weather forecast",
    "chart.trend": "Trend",
    "chart.weighting": "Weighting: {weather}% weather, {trend}% trend",
    "chart.actualPrices": "Actual prices",
    "chart.forecast": "Forecast",
    "chart.predictionWeighting": "Prediction Weighting",
    "chart.news": "News",
    "chart.regression": "Trend",
    "chart.addPrediction": "Add prediction",
    "chart.cancelPrediction": "Cancel",
    "chart.userPredictions": "My predictions",
    "chart.predictionMode": "Click on the chart to place a prediction",
    "chart.confirmPrediction": "Confirm prediction",
    "chart.predictionValue": "Value",
    "chart.predictionTime": "Time",
    "chart.savePrediction": "Save",
    "chart.cancel": "Cancel",
    "chart.predictionReasoning": "Prediction Analysis",
    "chart.reasoningHint":
      "Star-marked points have analysis - click to view",
    "chart.reasoningPlaceholder": "Enter your reasoning for this prediction...",
    "chart.reasoningRequired": "Analysis is required for all predictions",
    "chart.userPrediction": "User prediction",
    "chart.forecastDate": "Forecast date",
    "chart.forecastHour": "Hour",
    "chart.pinchToZoom": "Pinch to zoom",
    "chart.zoomHint": "Ctrl+scroll or drag to zoom",
    "chart.forecastDetails": "About this forecast",
    "chart.generated": "Generated",
    "chart.horizon": "Horizon",
    "chart.methods": "Methods",
    "chart.hoursAhead": "{count}h ahead",
    "chart.daysAhead": "{count} days ahead",
    "chart.forecastRange": "Forecast range",
    "chart.range7d": "7 days",
    "chart.range30d": "30 days",
    "chart.justNow": "just now",
    "chart.minutesAgo": "{count} min ago",
    "chart.hoursAgo": "{count} h ago",
    "chart.daysAgo": "{count} d ago",

    "login.banner": "Sign in to Spotprisprognos",
    "login.welcome": "Welcome back",
    "login.email": "Email",
    "login.password": "Password",
    "login.button": "Log in",
    "login.noAccount": "Don't have an account?",
    "login.registerLink": "Register here",
    "login.permissionsChanged":
      "Your permissions have been updated. Please log in again.",
    "login.incorrectCredentials": "Incorrect email or password.",

    "register.banner": "Get started with Spotprisprognos",
    "register.welcome": "Start Your Journey",
    "register.username": "Username",
    "register.email": "Email",
    "register.password": "Password",
    "register.confirmPassword": "Confirm Password",
    "register.button": "Register",
    "register.hasAccount": "Already have an account?",
    "register.loginLink": "Log in here",
    "register.checkEmailTitle": "Check your email",
    "register.successMessagePrefix": "A verification email has been sent to",
    "register.successMessageSuffix":
      ". Please check your inbox and click the verification link to activate your account.",
    "register.goToLogin": "Go to Login",
    "register.emailExists":
      "An account with this email already exists. Try logging in instead.",
    "register.genericError":
      "Something went wrong during registration. Please try again.",
    "register.privacyPrefix":
      "When you create an account, we process your personal data in accordance with our",
    "register.privacyLink": "privacy policy",

    "emailVerification.banner": "Email Verification",
    "emailVerification.successTitle": "Thank you!",
    "emailVerification.successMessage":
      "Your email address has been verified. You can now log in.",
    "emailVerification.goToLogin": "Go to Login",
    "emailVerification.errorTitle": "Verification Failed",
    "emailVerification.tokenExpired":
      "The verification link has expired. Request a new link below.",
    "emailVerification.tokenNotFound":
      "The verification link is invalid or has already been used.",
    "emailVerification.invalidToken": "Invalid verification link.",
    "emailVerification.genericError":
      "An error occurred while verifying your email.",
    "emailVerification.resendTitle": "Request New Verification Link",
    "emailVerification.emailPlaceholder": "Your email address",
    "emailVerification.emailRequired": "Email address is required",
    "emailVerification.resendButton": "Send New Link",
    "emailVerification.sending": "Sending...",
    "emailVerification.resendSuccess":
      "If an account with this email exists, we have sent a new verification link.",
    "emailVerification.resendFailed":
      "Failed to send verification email. Please try again.",
    "emailVerification.alreadyVerified":
      "This email address is already verified.",
    "emailVerification.backToLogin": "Back to Login",
    "login.emailNotVerified":
      "Your email address is not verified. Check your email or request a new verification link.",
    "login.resendVerification": "Resend Verification Link",
    "login.verificationResent":
      "Verification link sent! Check your email to activate your account.",
    "common.ok": "OK",

    "users.title": "Users",
    "users.subtitle": "Discover and follow other traders",
    "users.search": "Search users...",
    "users.loading": "Loading users...",
    "users.empty": "No users found.",
    "users.viewProfile": "View profile",
    "users.predictions": "predictions",
    "users.topUsers": "Top Users",
    "users.latestPredictions": "Latest Predictions",
    "users.noAccess": "You do not have permission to view users. Contact an administrator for access.",


    "account.title": "My Account",
    "account.subtitle": "Manage your profile and settings",
    "account.apiDocsButton": "Docs",
    "account.apiDocsTitle": "API documentation",
    "account.apiDocsIntro": "All endpoints require the header",
    "account.apiDocsBaseUrl": "Base URL",
    "account.apiDocsRateLimit": "Default rate limit: 1,000 requests/hour per key. Contact an admin if you need more.",
    "account.apiDocsParam": "Parameter",
    "account.apiDocsRequired": "Required",
    "account.apiDocsExample": "Example",
    "account.apiDocsDescription": "Description",
    "account.apiDocsYes": "Yes",
    "account.apiDocsNo": "No",
    "account.apiDocsCopy": "Copy",
    "account.apiDocsCopied": "Copied!",
    "account.apiDocsHasAccess": "Access",
    "account.apiDocsNoAccess": "No access",
    "account.apiDocsContactAdmin": "You don't have access to this endpoint. Contact an administrator to get access.",
    "account.apiDocsUpgradePremium": "This endpoint is part of Premium. Upgrade your account to get access.",
    "account.settings": "Profile Settings",
    "account.profileImage": "Profile Image",
    "account.changeImage": "Change Image",
    "account.username": "Username",
    "account.usernamePlaceholder": "Enter username",
    "account.email": "Email",
    "account.save": "Save",
    "account.cancel": "Cancel",
    "account.edit": "Edit",
    "account.predictions": "Predictions",
    "account.myPredictions": "My Predictions",
    "account.noPredictions": "You have no predictions yet.",
    "account.loading": "Loading...",
    "account.notFound": "Account not found.",
    "account.imageUrl": "Image URL",
    "account.imageUrlHint": "Enter a URL to your profile image",
    "account.viewAnalysis": "View analysis",
    "account.predicted": "Predicted",
    "account.analysis": "Analysis",
    "account.close": "Close",

    "navbar.admin": "Administration",

    "admin.title": "Administration",
    "admin.subtitle": "Manage users and roles",
    "admin.searchUsers": "Search users...",
    "admin.users": "Users",
    "admin.usersCount": "users",
    "admin.sortUsers": "Sort users",
    "admin.sortNewest": "Newest first",
    "admin.sortActive": "Recently active",
    "admin.sortName": "Email A–Z",
    "admin.userCreated": "Created",
    "admin.userLastLogin": "Last login",
    "admin.userLastSeen": "Last active",
    "admin.availableRoles": "Available Roles",
    "admin.editRoles": "Edit Roles",
    "admin.editRolesFor": "Edit roles for",
    "admin.selectRoles": "Select which roles the user should have:",
    "admin.noRoles": "No roles",
    "admin.cancel": "Cancel",
    "admin.saving": "Saving...",
    "admin.saveChanges": "Save Changes",
    "admin.roleDescriptions.admin": "Full administrative access",
    "admin.roleDescriptions.premium": "Access to all resources",
    "admin.roleDescriptions.basic": "Access to electricity and documents",
    "admin.roleDescriptions.free": "Electricity prices only",
    "admin.rolesTab": "Roles",
    "admin.permissionsTab": "Permissions",
    "admin.settingsTab": "Settings",
    "admin.insightsTab": "User insights",
    "admin.analyticsLink": "Prediction accuracy",
    "admin.upgradesTab": "Plan upgrades",
    "admin.upgradesTitle": "Pending upgrade requests",
    "admin.upgradesEmpty": "No pending upgrade requests.",
    "admin.upgradesUser": "User",
    "admin.upgradesCurrent": "Current",
    "admin.upgradesRequested": "Requested",
    "admin.upgradesWhen": "Requested at",
    "admin.upgradesAction": "Action",
    "admin.upgradesApprove": "Approve",
    "admin.upgradesReject": "Reject",
    "admin.upgradeApproved": "Upgrade approved.",
    "admin.upgradeRejected": "Upgrade rejected.",
    "admin.createRole": "Create Role",
    "admin.editPermissions": "Edit Permissions",
    "admin.editPermissionsFor": "Edit permissions for",
    "admin.deleteRole": "Delete Role",
    "admin.permissionsCount": "permissions",
    "admin.noPermissions": "No permissions",
    "admin.allPermissions": "All Permissions",
    "admin.selectPermissions": "Select which permissions the role should have:",
    "admin.roleName": "Role Name",
    "admin.roleNamePlaceholder": "Enter role name...",

    "admin.success.rolesUpdated": "Roles updated",
    "admin.success.roleCreated": "Role created",
    "admin.success.roleDeleted": "Role deleted",
    "admin.success.permissionsUpdated": "Permissions updated",
    "admin.success.planCreated": "Plan created",
    "admin.success.planUpdated": "Plan updated",
    "admin.success.planDeleted": "Plan deleted",
    "admin.success.planAssigned": "Plan assigned",
    "admin.success.settingUpdated": "Setting updated",
    "admin.success.userDeleted": "User deleted",
    "admin.deleteUser": "Delete User",
    "admin.confirmDeleteUser": "Are you sure you want to delete this user? All data will be permanently removed.",
    "account.deleteAccount": "Delete Account",
    "account.confirmDeleteAccount": "Are you sure you want to delete your account? All your data will be permanently removed and this cannot be undone.",
    "account.accountDeleted": "Account has been deleted",

    "admin.plans": "Plans",
    "admin.createPlan": "Create Plan",
    "admin.editPlan": "Edit Plan",
    "admin.deletePlan": "Delete Plan",
    "admin.planName": "Plan Name",
    "admin.planDescription": "Description",
    "admin.planRoles": "Plan Roles",
    "admin.planPrice": "Price",
    "admin.planPerMonth": "mo",
    "admin.planFree": "Free",
    "admin.planActiveDays": "Active days",
    "admin.planDaysPerMonth": "days/mo",
    "admin.planUnlimited": "Unlimited",
    "admin.planApiRequests": "API requests",
    "admin.planMaxActiveDays": "Max active days / month",
    "admin.planMaxActiveDaysHint": "Leave empty for unlimited. Otherwise the user is blocked after X active days in the month.",
    "admin.planApiMonthly": "API calls / month",
    "admin.planApiMonthlyHint": "Leave empty for no API access at all. Otherwise cap calls per calendar month.",
    "admin.planApiRpm": "API calls / minute",
    "admin.planApiRpmHint": "Leave empty for no per-minute cap (only matters when the monthly quota is set).",
    "admin.planIsHidden": "Hidden (admin-assigned only)",
    "admin.planIsHiddenHint": "Hidden plans (e.g. Admin/Superadmin) don't appear in the user's plan-change menu.",
    "admin.planIsInternal": "Internal (admin-assigned only)",
    "admin.planIsInternalHint": "Internal plans (e.g. Admin/Superadmin) never appear on the pricing page or in the user's plan-change menu.",
    "admin.planInternalBadge": "Internal",
    "admin.planPriceSek": "Price (SEK/month)",
    "admin.planPriceSekHint": "Shown on the public pricing page. Leave empty if the plan is free or internal.",
    "admin.planNoPricePlaceholder": "No price",
    "pricing.title": "Pricing",
    "pricing.subtitle": "Pick a plan that fits you. Upgrade or downgrade whenever you like.",
    "pricing.month": "mo",
    "pricing.free": "Free",
    "pricing.cta": "Get started",
    "pricing.back": "Back",
    "admin.planUnlimitedPlaceholder": "Unlimited",
    "admin.planNoAccessPlaceholder": "No access",
    "admin.planNoRpmPlaceholder": "No cap",
    "admin.planMoveUp": "Move up",
    "admin.planMoveDown": "Move down",
    "admin.planDragHint": "Drag to reorder",
    "admin.planNameRequired": "Plan name is required.",
    "admin.planSaveFailed": "Couldn't save the plan.",
    "admin.defaultSignupPlan": "Default Signup Plan",
    "admin.defaultPlanHint": "New users are automatically assigned this plan on registration.",
    "admin.noDefaultPlan": "None (no plan assigned)",
    "admin.assignPlan": "Assign Plan",
    "admin.changePlan": "Change plan",
    "admin.userPlan": "Plan",
    "admin.noPlan": "No plan",
    "admin.planUsers": "users",
    "admin.planNamePlaceholder": "Enter plan name...",
    "admin.planDescriptionPlaceholder": "Describe the plan...",
    "admin.confirmDeletePlan": "Are you sure you want to delete the plan",
    "admin.noPlans": "No plans created yet.",
    "admin.planRolesCount": "roles",
    "account.planLabel": "Subscription",
    "account.planNone": "No plan",
    "account.planUpgrade": "Upgrade",
    "account.planChange": "Change plan",
    "account.planChangeIntro": "Pick the plan you'd like to switch to. An administrator needs to approve your request before it takes effect.",
    "account.planChangeApprovalNote": "Your request must be approved by an administrator. You'll stay on your current plan until then.",
    "account.planRequestUpgrade": "Send request",
    "account.planUpgradeIntro": "Choose the plan you'd like to upgrade to. An administrator needs to approve your request before it takes effect.",
    "account.planUpgradeApprovalNote": "Your request must be approved by an administrator. You'll stay on your current plan until then.",
    "account.planPendingRequest": "You already have a pending upgrade request. An administrator is reviewing it.",
    "account.planTopTier": "You're already on our top plan.",
    "account.planManagedManually": "Your plan is assigned manually — you already have access to all features.",
    "account.planCheckoutNote": "You'll be redirected to Stripe to complete payment. Your plan activates right after payment.",
    "account.planTermsPrefix": "By continuing you agree to our",
    "account.planTermsLink": "terms of purchase",
    "account.planContinueToPayment": "Continue to payment",
    "account.planSwitchNote": "You'll be redirected to Stripe to confirm the plan change. The switch takes effect immediately: upgrades charge the prorated difference now, downgrades credit it on your next invoice.",
    "account.planContinueToSwitch": "Continue to plan change",
    "account.planCancelNote": "You'll be redirected to Stripe to cancel your subscription. You keep your plan until the end of the billing period, then move to Free.",
    "account.planContinueToCancel": "Continue to cancel",
    "account.planCancellationPending": "Your subscription ends on {date}. After that you'll move to the Free plan.",
    "account.planResumeSubscription": "Resume subscription",
    "account.manageSubscription": "Manage subscription",
    "billing.activatingTitle": "Activating your subscription …",
    "billing.activatingBody": "Hang tight while we confirm your payment.",
    "billing.successTitle": "Thanks! Your subscription is active.",
    "billing.successBody": "Your new plan is now active.",
    "billing.pendingTitle": "Payment processing",
    "billing.pendingBody": "This can take a moment. Your plan will update automatically once payment completes.",
    "billing.cancelledTitle": "Checkout cancelled",
    "billing.cancelledBody": "No changes were made. You can try again whenever you like.",
    "billing.backToAccount": "Back to account",

    "navbar.analytics": "Analytics",
    "analytics.title": "Prediction accuracy",
    "analytics.subtitle": "Validation and precision per method, target and time window.",
    "analytics.forecastVsActual": "Forecast vs actual",
    "navbar.articles": "Articles",
    "articles.title": "Articles",
    "articles.beta": "Testing · admins only",
    "articles.subtitle": "Long-form analysis of the electricity market, once a month, written from our own data.",
    "articles.kicker": "Monthly analysis",
    "articles.byline": "Spotprisprognos",
    "articles.minutes": "{count} min read",
    "articles.empty": "No published articles yet.",
    "articles.noAccess": "Articles are only available to administrators for now.",
    "articles.loadError": "The articles could not be loaded.",
    "articles.notFound": "The article does not exist or is not published.",
    "articles.adminOnly": "Visible to administrators only",
    "articles.status.draft": "Draft",
    "articles.status.published": "Published",
    "articles.status.removed": "Removed",
    "articles.publish": "Publish",
    "articles.unpublish": "Unpublish",
    "articles.remove": "Remove",
    "articles.deleteForever": "Delete for good",
    "articles.confirmRemove": "Remove \"{title}\"? It disappears from the list but can be restored.",
    "articles.confirmDelete": "Delete \"{title}\" for good? This cannot be undone.",
    "articles.coverCaption": "Illustration: AI-generated (Mistral)",
    "articles.disclosure": "Written by an AI model (Mistral Large) from Spotprisprognos' own data on prices, generation and news, and reviewed before publication. Not financial advice.",
    "articles.sources": "Sources",
    "articles.link": "Link",
    "articles.adminTitle": "Articles",
    "articles.adminSub": "Uploaded as drafts by scripts/generate_article.py",
    "articles.adminEmpty": "No articles uploaded yet.",
    "articles.colTitle": "Title",
    "articles.colStatus": "Status",
    "articles.colCreated": "Uploaded",
    "articles.colPublished": "Published",
    "articles.colWords": "Words",
    "models.title": "Model comparison",
    "models.standard": "Standard",
    "models.pro": "Pro",
    "models.naive": "Naive (last week)",
    "models.naiveDesc": "The price the same hour one or more whole weeks before the forecast, which was known when the forecast was made. A model should beat this.",
    "models.unit": "öre/kWh",
    "models.scope": "Zones",
    "models.allZones": "All zones",
    "models.wholeCountry": "All of {country}",
    "models.period": "Period",
    "models.anchor": "Forecast time",
    "models.anchorAt": "Forecast from {hour}:00 UTC",
    "models.overlap": "Shared hours only",
    "models.hint": "One forecast per model, zone and day (the first after the chosen time) is compared hour by hour with the actual spot price. With \"shared hours only\", only hours both models forecast are counted.",
    "models.error": "The model comparison could not be loaded.",
    "models.best": "Best",
    "models.noRows": "No forecasts in this period.",
    "models.mae": "MAE",
    "models.rmse": "RMSE",
    "models.bias": "Bias",
    "models.skill": "Skill",
    "models.vsNaive": "vs naive",
    "models.cheap3": "Cheapest 3 h",
    "models.days": "{count} days",
    "models.hours": "Hours",
    "models.scored": "scored",
    "models.byLead": "Error by lead time",
    "models.byLeadSub": "MAE per day ahead of the forecast",
    "models.lead": "Lead",
    "models.leadDays": "{range} days",
    "models.trend": "Error over time",
    "models.trendSub": "MAE for the next 48 hours, per forecast day",
    "models.perZone": "Per zone",
    "models.zone": "Zone",
    "analytics.noData": "No data available for selected period.",
    "analytics.electricity": "Electricity",
    "analytics.commodities": "Commodities",
    "analytics.allTargets": "All",
    "analytics.days": "days",
    "analytics.lastDays": "Last {count} days",
    "analytics.totalValidated": "Validated predictions",
    "analytics.avgAccuracy": "Average accuracy",
    "analytics.directionAccuracy": "Direction accuracy",
    "analytics.bestMethod": "Best method",
    "analytics.methodComparison": "Method Comparison",
    "analytics.method": "Method",
    "analytics.method.weather": "Weather",
    "analytics.method.regression": "Regression",
    "analytics.method.news": "News",
    "analytics.method.user": "User",
    "analytics.predictions": "Predictions",
    "analytics.avgScore": "Avg score",
    "analytics.avgDistance": "Avg distance",
    "analytics.direction": "Direction",
    "analytics.bestScore": "Best",
    "analytics.worstScore": "Worst",
    "analytics.accuracyOverTime": "Accuracy Over Time",
    "analytics.predictionDetails": "Prediction Details",
    "analytics.total": "total",
    "analytics.targetTime": "Target time",
    "analytics.generatedAt": "Generated",
    "analytics.predicted": "Predicted",
    "analytics.distance": "Distance",
    "analytics.score": "Score",
    "analytics.type": "Type",
    "analytics.viewReasoning": "View reasoning",
    "analytics.reasoning": "Reasoning",
    "analytics.userLeaderboard": "User Leaderboard",
    "analytics.user": "User",
    "analytics.anonymous": "Anonymous",
    "analytics.allTypes": "All types",
    "analytics.filter": "Filter",
    "analytics.customRange": "Custom",
    "analytics.startDate": "From",
    "analytics.endDate": "To",
    "analytics.actual": "Actual",
    "analytics.noValidation": "No validation data available yet for this period.",
    "analytics.timelineMetric": "Metric",
    "analytics.userActivity": "User activity",
    "analytics.noActivity": "No activity in this period.",
    "analytics.noEvents": "No events for this user.",
    "analytics.activeDays": "Active days",
    "analytics.activeDaysMonth": "Active days / month",
    "analytics.apiCallsMonth": "API calls / month",
    "analytics.plan": "Plan",
    "analytics.pageViews": "Page views",
    "analytics.areaToggles": "Area toggles",
    "analytics.ctaClicks": "CTA clicks",
    "analytics.modalOpens": "Modals",
    "analytics.lastActive": "Last active",
    "analytics.event": "Event",
    "analytics.target": "Target",
    "analytics.when": "When",
  },
};

/**
 * Build a translate function bound to a fixed language, independent of the
 * LanguageProvider's active language. Used by the anonymous auth pages
 * (/welcome, /login, /register, /email-verified) which are intentionally
 * Swedish-only so signup doesn't flip between languages mid-flow.
 */
export const createT = (language: SupportedLanguage) => {
  return (key: string, params: Record<string, string | number> = {}): string => {
    const dict = STRINGS[language] || {};
    let text = dict[key] || key;
    Object.keys(params).forEach((k) => {
      text = text.replace(`{${k}}`, String(params[k]));
    });
    return text;
  };
};
